import React from 'react'
import Select from 'react-select';

// components
import {
  CCol,
  CFormLabel,
} from '@coreui/react-pro'

const FormSelectInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  selectOptions,
  value,
  handleSelectInput,
  handleSearchInput,
  feedbackInvalid,
  invalid,
  disabled,
  isShowLabel = true,
  isShowInvalidErr = true,
  placeholder,
  componentSelect,
  isDetectSearch = false,
  multiple = false,
  isClearable = true
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {
        isShowLabel && (
          <CFormLabel>
            {inputLabel}
          </CFormLabel>
        )
      }
      <Select
        id={id}
        name={name}
        isMulti={multiple}
        options={selectOptions}
        className={`${invalid ? 'select-invalid' : ''}`}
        onChange={(e) => handleSelectInput(e)}
        onInputChange={(e) => {
          if (isDetectSearch) {
            handleSearchInput(e)
          }
        }}
        value={value}
        isDisabled={disabled}
        isSearchable={true}
        isClearable={isClearable}
        placeholder={placeholder}
        components={componentSelect}
      />
      {
        isShowInvalidErr && invalid && (
          <span className='error-text-field'>{feedbackInvalid || feedbackInvalid?.name}</span>
        )
      }
    </CCol>
  )
}

export default FormSelectInput
